import { Component, Input } from "@angular/core";

@Component({
    selector: "clare-spinner",
    templateUrl: "./clare-spinner.component.html",
    styleUrls: ["./clare-spinner.component.scss"],
})
export class ClareSpinnerComponent {
    @Input() text: string;
    @Input() position: "absolute" | "inline";
    @Input() textAlign: "left" | "right" | "center" = "center";
    @Input() overlay: boolean;
    @Input() inline = false;
}
